module.exports = __webpack_public_path__ + "media/images/app/visitors/bridal/hero_mobile-fb46f725250c0c8065b6fb62cf57ca66.webp";